<template>
  <v-dialog v-model="dialog_open" fullscreen hide-overlay transition="dialog-bottom-transition" scrollable>
    <v-card v-if="whatsapp_profile" class="whatsapp-profile" tile>
      <div class="whatsapp-profile-header">
        <img class="checkmotors-label" :src="require('@/assets/logo_check_motors_white.png')" />
        <div class="wph-action">
          <v-icon dark @click="dialog_open = false" style="cursor: pointer">mdi-arrow-left</v-icon
          ><span style="position: absolute; margin-left: 20px; font-size: 18px; margin-top: 0px">Perfil do cliente</span>
        </div>
        <div class="wph-info">
          <div v-if="whatsapp_profile.ss9s9722j2ko">
            <img :src="whatsapp_profile.ss9s9722j2ko" />
          </div>
          <div v-else>
            <img :src="require('@/assets/blank-profile-picture.svg')" />
          </div>
          <div class="wph-contat" @click="isModalManageClientOpen = true" @mouseenter="showEditClient" @mouseleave="hideEditClient">
            <div class="contact-name">{{ client ? client.name : (whatsapp_profile.sdkadas8uda8sd1 !== null ? whatsapp_profile.sdkadas8uda8sd1 : whatsapp_profile.g090s98sda8d6) }}</div>
            <div class="contact-number">{{ whatsapp_profile.g090s98sda8d6 ? formatPhone(whatsapp_profile.g090s98sda8d6) : '--' }}</div>
            <div class="contact-edit" :class="{ show: clientEdit }"><v-icon>mdi-pencil</v-icon> ALTERAR CLIENTE</div>
          </div>
        </div>
        <div class="wph-tabs">
          <v-tabs
            v-model="dialog_tab"
            color="#008069"
            background-color="#ebebeb"
            style="border-top: 1px solid rgb(214 214 214); height: 80px"
            height="80px"
            flat
            grow
          >
            <v-tab class="custom-tab">
              <v-icon>mdi-car-multiple</v-icon>
              <span>Serviços</span>
            </v-tab>
            <v-tab class="custom-tab">
              <v-icon>mdi-file-sign</v-icon>
              <span>Orçamentos</span>
            </v-tab>
            <v-tab class="custom-tab">
              <v-icon>mdi-calendar-clock</v-icon>
              <span>Agendamentos</span>
            </v-tab>
          </v-tabs>
        </div>
      </div>
      <v-card-text style="margin-top: 160px; padding: 0px !important">
        <v-tabs-items v-model="dialog_tab">
          <v-tab-item>
            <ListServiceOrders :client="client" @view="viewServiceOrder" ref="ListServiceOrders" />
            <div
              v-if="!client"
              class="no-client-found"
              style="
                margin-top: 50px;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                text-align: center;
                color: #666;
                font-size: 18px;
                padding-left: 20px;
                padding-right: 20px;
              "
            >
              <img style="height: 128px; filter: grayscale(1); opacity: 0.4" :src="require('@/assets/adicionar-usuario.png')" />
              <div style="margin-top: 20px; color: #a6a4a4">
                <b>Número não atrelado</b> <br /><small>Clique no botão abaixo para cadastrar um cliente ou atrelar um já existente.</small>
              </div>
              <v-btn large color="primary" elevation="0" style="margin-top: 20px; width: 140px" @click="isModalManageClientOpen = true"
                ><v-icon class="mr-3">mdi-plus-circle</v-icon> Cliente</v-btn
              >
            </div>
          </v-tab-item>
          <v-tab-item>
            <ListBudgets :client="client" />
            <div
              v-if="!client"
              class="no-client-found"
              style="
                margin-top: 50px;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                text-align: center;
                color: #666;
                font-size: 18px;
                padding-left: 20px;
                padding-right: 20px;
              "
            >
              <img style="height: 128px; filter: grayscale(1); opacity: 0.4" :src="require('@/assets/adicionar-usuario.png')" />
              <div style="margin-top: 20px; color: #a6a4a4">
                <b>Número não atrelado</b> <br /><small>Clique no botão abaixo para cadastrar um cliente ou atrelar um já existente.</small>
              </div>
              <v-btn large color="primary" elevation="0" style="margin-top: 20px; width: 140px" @click="isModalManageClientOpen = true"
                ><v-icon class="mr-3">mdi-plus-circle</v-icon> Cliente</v-btn
              >
            </div>
          </v-tab-item>
          <v-tab-item>
            <ListAppointments :client="client" />
            <div
              v-if="!client"
              class="no-client-found"
              style="
                margin-top: 50px;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                text-align: center;
                color: #666;
                font-size: 18px;
                padding-left: 20px;
                padding-right: 20px;
              "
            >
              <img style="height: 128px; filter: grayscale(1); opacity: 0.4" :src="require('@/assets/adicionar-usuario.png')" />
              <div style="margin-top: 20px; color: #a6a4a4">
                <b>Número não atrelado</b> <br /><small>Clique no botão abaixo para cadastrar um cliente ou atrelar um já existente.</small>
              </div>
              <v-btn large color="primary" elevation="0" style="margin-top: 20px; width: 140px" @click="isModalManageClientOpen = true"
                ><v-icon class="mr-3">mdi-plus-circle</v-icon> Cliente</v-btn
              >
            </div>
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>

      <div style="flex: 1 1 auto"></div>
    </v-card>

    <ModalManageClient v-if="isModalManageClientOpen" :isActive="isModalManageClientOpen" @close="closeModalManageClient" />

    <v-dialog v-model="iSServiceFlowDialogOpen" fullscreen hide-overlay transition="dialog-bottom-transition" class="container" scrollable>
      <ServiceFlow @return="closeServiceFlow" :view_service_order_id="view_service_order_id" />
    </v-dialog>
  </v-dialog>
</template>

<script>
import ModalManageClient from '@/components/ServiceOrder/Dialogs/ModalManageClient';
import ListServiceOrders from '@/components/WhatsApp/ListServiceOrders';
import ServiceFlow from '@/views/ServiceOrder/ServiceFlow';
import ClientService from '@/services/api/client';
import ListBudgets from '@/components/WhatsApp/ListBudgets';
import ListAppointments from '@/components/WhatsApp/ListAppointments';

export default {
  name: 'WhatsappProfile',
  props: {
    whatsapp_profile: Object
  },
  components: {
    ListServiceOrders,
    ListBudgets,
    ListAppointments,
    ModalManageClient,
    ServiceFlow
  },
  data() {
    return {
      isModalManageClientOpen: false,
      iSServiceFlowDialogOpen: false,
      view_service_order_id: null,
      dialog_open: false,
      dialog_tab: 0,
      notifications: false,
      sound: true,
      widgets: false,
      client: {
        id: null
      },
      clientEdit: false
    };
  },
  watch: {
    whatsapp_profile: {
      handler(profile) {
        this.isModalManageClientOpen = false;
        this.iSServiceFlowDialogOpen = false;

        if (profile.iid98d === 'contact') {
          this.dialog_open = true;
          this.checkIfUserIsAnClient();
        } else {
          this.dialog_open = false;
        }
      }
    }
  },
  mounted() {
    if (this.$store.getters['Auth/user']) {
      this.$store.dispatch('ClientClassification/getClientClassifications');
    }
  },
  methods: {
    checkIfUserIsAnClient() {
      ClientService.getByPhone(this.whatsapp_profile.g090s98sda8d6)
        .then((response) => {
          this.client = response.data.client ?? null;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    closeModalManageClient(client) {
      this.isModalManageClientOpen = false;

      if (client) {
        const phone = this.whatsapp_profile.g090s98sda8d6;

        ClientService.updatePhone(client.id, { phone })
          .then((response) => {
            this.client = response.data.client ?? null;

            this.checkIfUserIsAnClient();
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    viewServiceOrder(service) {
      this.view_service_order_id = service.id;
      this.iSServiceFlowDialogOpen = true;
    },
    closeServiceFlow(refresh) {
      this.view_service_order_id = null;
      this.iSServiceFlowDialogOpen = false;

      if (refresh) {
        this.$refs.ListServiceOrders.refreshServiceOrders();
      }
    },
    formatPhone(phone) {
      let phoneNumbers = phone.replace(/\D/g, '');
      if (phoneNumbers.startsWith('55')) {
        phoneNumbers = phoneNumbers.substring(2);
      }
      const format = '($1) $2-$3';
      return phoneNumbers.replace(/(\d{2})(\d{4,5})(\d{4})/, format);
    },
    showEditClient() {
      this.clientEdit = true;
    },
    hideEditClient() {
      this.clientEdit = false;
    }
  }
};
</script>

<style lang="scss">
.whatsapp-profile {
  .whatsapp-profile-header {
    height: 108px;
    background-color: #008069;
    color: #fff;

    .checkmotors-label {
      height: 44px;
      position: fixed;
      width: auto;
      right: 0px;
      margin: 15px 25px;
      background-color: #ffffff1c;
      border-radius: 6px;
    }

    .wph-action {
      padding: 20px;
    }

    .wph-info {
      overflow: hidden;

      img {
        display: block;
        border-radius: 50%;
        border: 6px solid #ebebeb;
        margin: 0px 16px;
        float: left;
        width: 108px;
        min-width: 108px;
        height: 108px;
        min-height: 108px;
        background-color: #fff;
      }

      .wph-contat {
        cursor: pointer;
        background-color: #fff;
        display: block;
        float: left;
        color: #666;
        padding: 10px;
        border-radius: 6px;
        border: 2px solid rgb(214, 214, 214);
        margin-top: 10px;
        width: calc(100% - 160px);
        position: relative;
        overflow: hidden;

        .contact-edit {
          position: absolute;
          bottom: -100%;
          left: 0;
          width: 100%;
          background-color: #eeeeeee0;
          color: #a6a4a4;
          font-weight: bold;
          text-align: center;
          padding: 30px;
          transition: bottom 0.3s ease-in-out;

          &.show {
            bottom: 0;
          }
        }
      }

      .contact-name {
        font-size: 18px;
        font-weight: bold;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .contact-number {
        border-top: 1px solid rgb(214, 214, 214);
        padding-top: 5px;
        margin-top: 5px;
      }
    }

    .wph-tabs {
      background-color: #ebebeb;
      height: 117px;
      padding-top: 70px;
      margin-top: -64px;

      .custom-tab {
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
        width: 113px;

        span {
          font-size: 11px;
          padding-top: 3px;
        }
      }
    }
  }
}
</style>
